import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import LandingPage from './pages/LandingPage';

const NotionCourseEditor = lazy(() => import('./screens/NotionCourseEditor'));
const FeaturesPage = lazy(() => import('./pages/FeaturesPage'));
const HelpPage = lazy(() => import('./pages/HelpPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const DictationPage = lazy(() => import('./pages/DictationPage'));
const ShadowingPage = lazy(() => import('./pages/ShadowingPage'));

const routeFallback = (
  <div style={{ minHeight: '100vh', background: '#ffffff' }} aria-hidden="true" />
);

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  const location = useLocation();

  if (!token) {
    const redirectPath = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={`/product?from=${encodeURIComponent(redirectPath)}`} replace />;
  }

  return children;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Suspense fallback={routeFallback}>
          <Routes>
            <Route path="/" element={<Navigate to="/product" replace />} />
            <Route path="/product" element={<LandingPage />} />
            <Route
              path="/editor"
              element={
                <PrivateRoute>
                  <NotionCourseEditor />
                </PrivateRoute>
              }
            />
            <Route
              path="/home"
              element={<Navigate to="/editor" replace />}
            />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/dictation" element={<DictationPage />} />
            <Route path="/shadowing" element={<ShadowingPage />} />
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
}

export default App;
